// extracted by mini-css-extract-plugin
module.exports =  {"button":"yhqegCD0PIgY9x8JxjSe","container":"_ySHVoEGpOk9ECS4LpLA","content":"cuiadwOL6FMlzE8r2K4u","person":"ppG24QbzndzUcMYAmXXA","timeline":"KbMPwHj_qGniSLd03ksV"};